import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5bb27c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expansion" }, null, -1))

import { useBackgroundUrl } from '@/components/workshop/useWorkshopImg';
import { ImageBoxType } from './type';


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  props: {
    type: { default: ImageBoxType.Create },
    isSelected: { type: Boolean, default: false },
    image: null,
    size: null
  },
  emits: ["erase"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'erase'): void;
}), expose: any, slots: any, attrs: any }) {

_useCssVars(_ctx => ({
  "054ac5d3": (_unref(imageBoxUsed).pc),
  "50530360": (_unref(imageBox).pc),
  "1f888bac": (_unref(imageBoxActive).pc),
  "da3e74d6": (_unref(iconErase).pc),
  "27b246c8": (_unref(iconEraseGlow).pc)
}))




const { imageBox, imageBoxActive, imageBoxUsed, iconErase, iconEraseGlow } =
  useBackgroundUrl();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['box', `box--${__props.type}`, { 'box--selected': __props.isSelected }]),
    style: _normalizeStyle({ width: `${__props.size}rem`, height: `${__props.size}rem` })
  }, [
    (__props.type === _unref(ImageBoxType).Edit)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "box__erase",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('erase')))
        }))
      : _createCommentVNode("", true),
    (__props.image)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "box__img",
          style: _normalizeStyle({
        backgroundImage: `url(${__props.image})`,
        width: `${__props.size}rem`,
        height: `${__props.size}rem`,
      })
        }, null, 4))
      : _createCommentVNode("", true),
    _hoisted_1
  ], 6))
}
}

})